export default {
  setProfileInfo: (state, data) => {
    state.profileInfo = data.content;
  },
};
